import { render, staticRenderFns } from "./NombrePacienteComponente.vue?vue&type=template&id=2753c24b"
import script from "./NombrePacienteComponente.vue?vue&type=script&lang=js"
export * from "./NombrePacienteComponente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports